// ======================================================================
// File: PRLineTable.jsx
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Display consolidated PR line items
// - Read-only table
// - Show indent traceability
//
// UI Pattern:
// - Cloned from IndentItemTable.jsx
// - Aligned with PR UI standards
// ======================================================================

import React from "react";
import IndentReferencePopover from "../components/IndentReferencePopover";
import {
  formatDate,
  formatQuantity,
} from "../../../../../../utils/formatUtils";

export default function PRLineTable({
  prId,
  lines = []
}) {

  if (!lines || lines.length === 0) {
    return (
      <div className="pr-empty-state">
        No materials consolidated yet
      </div>
    );
  }

  return (
    <div className="pr-table-wrapper">
      <table className="pr-table">
        <thead>
          <tr>
            <th>Material</th>
            <th>PR Qty</th>
            <th>UOM</th>
            <th>Required Date</th>
            <th>Indent Ref</th>
            <th>RFQ Qty</th>
            <th>Ordered Qty</th>
          </tr>
        </thead>

        <tbody>
          {lines.map((line) => (
            <tr key={line.id}>
              <td>
                <div className="material-name">
                  {line.material_name || `#${line.material_id}`}
                </div>
                <div className="material-type">
                  {line.material_type}
                </div>
              </td>

              <td>{formatQuantity(line.requested_qty)}</td>

              <td>{line.uom}</td>

              <td>
                {line.required_date
                  ? formatDate(line.required_date)
                  : "-"}
              </td>

              <td>
                <IndentReferencePopover
                  prId={prId}
                  prLineId={line.id}
                />
              </td>

              <td>{formatQuantity(line.rfq_qty || 0)}</td>

              <td>{formatQuantity(line.ordered_qty || 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
